import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { isEqual } from 'lodash';
import { PagePermissionEntityInterface } from '@types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControlLabel,
  FormGroup,
  Switch,
  Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { PermissionActions } from '@enums';
import { useGetCurrentRolePermissions } from '@hooks/useSetCurrentRolePermissions';
import { setCurrentRolePermissions } from '@actions/roleActions';
import { FeatureConfigurationList } from './FeatureConfigurationList';

interface props {
  pagePermission: PagePermissionEntityInterface;
}
export const PagePermissionsAccordion = ({ pagePermission }: props) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(pagePermission[PermissionActions.View]);
  const [expanded, setExpanded] = useState<boolean>(false);
  const [currentPagePermission, setCurrentPagePermission] = useState(pagePermission);
  const actualRolePermissions = useGetCurrentRolePermissions(currentPagePermission);
  const dispatch = useDispatch();

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsEnabled(e.target.checked);
  };

  useEffect(() => {
    if (pagePermission[PermissionActions.View] !== isEnabled) {
      setCurrentPagePermission({ ...currentPagePermission, view: isEnabled });
      if (!isEnabled) {
        setExpanded(isEnabled);
      }
    }
  }, [isEnabled]);

  useEffect(() => {
    if (actualRolePermissions && !isEqual(pagePermission, currentPagePermission)) {
      dispatch(setCurrentRolePermissions(actualRolePermissions));
    }
  }, [actualRolePermissions, currentPagePermission]);

  return (
    <>
      <FormGroup className="page-permission-container">
        <Accordion
          disabled={!isEnabled}
          data-testid={`accordion-${pagePermission.name}`}
          expanded={expanded}
          onChange={() => pagePermission?.featurePermissions?.length && setExpanded(!expanded)}
        >
          <Box sx={{ display: 'flex' }}>
            <FormControlLabel
              control={
                <Switch
                  data-testid={`accordion-toggle-${pagePermission.name}`}
                  checked={isEnabled}
                  onChange={handleToggle}
                  name={pagePermission.name}
                />
              }
              label=""
            />
            <AccordionSummary
              expandIcon={
                pagePermission?.featurePermissions?.length ? (
                  <ExpandMore
                    data-testid={`accordion-summary-expand-icon-${pagePermission.name}`}
                  />
                ) : (
                  <></>
                )
              }
            >
              <Typography
                data-testid={`accordion-summary-title-${pagePermission.name}`}
                className="page-permissions-heading"
                component="h3"
                variant="h2"
              >
                {pagePermission.title}
              </Typography>
            </AccordionSummary>
          </Box>
          <AccordionDetails>
            <FeatureConfigurationList pagePermission={pagePermission} />
          </AccordionDetails>
        </Accordion>
      </FormGroup>
    </>
  );
};
